module.exports = __webpack_public_path__ + "static/media/useCase83x.a0528338.png";